<template>
    <div class="index">
        <!--首屏-->
        <div class="home-page" id="homePage">
            <img class="homePageImg" :src="getImgUrl('dataMock/homePage/HPbanner1.png')" />
            <div class="hpBanner">
                <div class="hpBanner-loge">
                    <embed class="hpBanner-img" :src="`${$baseUrl}dataMock/homePage/pkpmLogo.png`" />
                    <h1 class="hpBanner-ctx">BIMBase 云平台</h1>
                </div>
                <!-- 大屏下的导航 -->
                <div class="hpBanner-header-lg">
                    <div class="hpBanner-menu" v-for="item in topMenu" :key="item.id" @click="scrollIntoView(item.id)">
                        {{ item.title }}
                    </div>
                </div>
                <!-- 小屏幕下的导航 -->
                <div class="hpBanner-header-sm">
                    <div class="navicon-bar" @click="navClick()">
                        <i class="fa fa-navicon"></i>
                    </div>
                    <transition name="fade">
                        <div v-if="this.naviconShow" class="hpBanner-menuGroup">
                            <div
                                class="hpBanner-menu"
                                v-for="item in topMenusm"
                                :key="item.id"
                                @click="scrollIntoView(item.id)"
                            >
                                {{ item.title }}
                            </div>
                        </div>
                    </transition>
                </div>
                <div class="hpBanner-login">
                    <router-link :to="{ path: '/devcenter' }" class="loginCenter" tag="span">开发者中心</router-link>
                    <div v-if="userName" :title="userName" class="loginCenter loginSty">{{ userName }}</div>
                    <div v-else class="loginSty" @click="indexUserLogin">登录</div>
                </div>
            </div>
            <div class="hpContent">
                <h3>国内建筑行业领导者</h3>
                <h2>BIM云平台一站式解决方案</h2>
                <h3>帮助BIM应用的开发者，快速搭建自己的BIM平台，让你的系统插上BIM的翅膀</h3>
                <div class="hpContent-btnGroup">
                    <!-- <div class="hpContent-btn" @click="pathTo('/devcenter')">
    <i class="fa fa-server"></i>
    &nbsp开发者中心
  </div> -->
                    <div class="hpContent-btn" @click="indexUserLogin">
                        免费注册
                    </div>
                </div>
            </div>
            <div class="hpFeature" v-if="obvFeatureData.length > 0">
                <div class="hpFeature-sub" v-for="(item, index) in obvFeatureData" :key="index">
                    <div class="subImage-container">
                        <img class="subImage" :src="getImgUrl(item.imgURL)" />
                    </div>
                    <h2>{{ item.title }}</h2>
                    <h3 class="hidden-xs">{{ item.detail }}</h3>
                </div>
            </div>
        </div>
        <!--功能介绍-->
        <div class="features-introduce" id="featuresIntroduce" v-if="featureIntroduceData.length > 0">
            <div class="subIntroduce" v-for="(item, index) in featureIntroduceData" :key="index">
                <div v-if="index % 2 === 0" class="subLeft left">
                    <img class="subImage" :src="getImgUrl(item.imgURL)" />
                    <div class="subBG"></div>
                </div>
                <div v-if="index % 2 === 0" class="subRight right">
                    <span>{{ item.title }}</span>
                    <span>{{ item.detail }}</span>
                </div>
                <div v-if="index % 2 !== 0" class="subRight left">
                    <span>{{ item.title }}</span>
                    <span>{{ item.detail }}</span>
                </div>
                <div v-if="index % 2 !== 0" class="subLeft right">
                    <img class="subImage" :src="getImgUrl(item.imgURL)" />
                    <div class="subBG"></div>
                </div>
            </div>
        </div>
        <!-- 解决方案 -->
        <homeSolutions :solutionsData="solutionsData" />
        <!--应用案例-->
        <homeCases :caseData="caseData" />
        <!-- 价格 -->
        <homePice />
        <!--关于我们-->
        <!-- <homeAboutUs :aboutUsData='aboutUsData' /> -->
        <!-- 固定标签 -->
        <cfixed />
        <!--footer-->
    </div>
</template>

<script>
// import viewModel from '../../components/view-model'
import $ from 'jquery';
import { homePageUrl } from 'src/api/data';
import { get } from 'src/utils/httpUtil';
import { userLogin, getUserNameFun } from 'src/utils/loginUtils';
import cfixed from 'src/components/cfixed';
import homeCases from 'src/pages/index/home-cases';
import homeSolutions from 'src/pages/index/home-solutions';
import homePice from 'src/pages/index/home-price';
import homeAboutUs from 'src/pages/index/home-aboutUs';

export default {
    name: 'index',
    components: {
        homeCases,
        homeSolutions,
        homePice,
        homeAboutUs,
        cfixed,
    },
    data() {
        return {
            topMenu: [
                {
                    id: 'featuresIntroduce',
                    title: '产品介绍',
                },
                {
                    id: 'solutions',
                    title: '解决方案',
                },
                {
                    id: 'cases',
                    title: '用户案例',
                },
                {
                    id: 'price',
                    title: '价格',
                },
                {
                    id: 'playground',
                    title: '代码示例',
                },
                {
                    id: 'question',
                    title: '常见问题',
                },
                //20210309 by wyx
                {
                    id: 'logs',
                    title: '更新日志',
                },
                // {
                //     id: 'application',
                //     title: '应用场景',
                // },
                // },{
                //   id: 'aboutUs',
                //   title:'关于我们'
                // }
            ],
            topMenusm: [
                {
                    id: 'featuresIntroduce',
                    title: '产品介绍',
                },
                {
                    id: 'solutions',
                    title: '解决方案',
                },
                {
                    id: 'cases',
                    title: '用户案例',
                },
                {
                    id: 'price',
                    title: '价格',
                },
                {
                    id: 'devcenter',
                    title: '开发者中心',
                },
                {
                    id: 'playground',
                    title: '代码示例',
                },
                {
                    id: 'question',
                    title: '常见问题',
                },
                //20210309 by wyxs
                {
                    id: 'logs',
                    title: '更新日志',
                },
                // {
                //     id: 'application',
                //     title: '应用场景',
                // },
                // },{
                //   id: 'aboutUs',
                //   title:'关于我们'
                // }
            ],
            naviconShow: false, // 下拉菜单显示
            obvFeatureData: [], // obv特点数据
            featureIntroduceData: [], // 特点介绍数据
            solutionsData: [], // 解决方案数据
            caseData: [], // 用户案例数据
            aboutUsData: {}, // 关于我们数据
            currentShow: 2,
            vcarousel3: null,
            Carousel: null,
            userName: '',
        };
    },
    computed: {},
    methods: {
        navClick() {
            this.naviconShow = !this.naviconShow;
        },
        scrollIntoView(id) {
            if (id === 'featuresIntroduce' || id === 'solutions' || id === 'cases' || id === 'price') {
                document.querySelector(`#${id}`).scrollIntoView();
            } else if (id === 'devcenter') {
                this.$router.push('/devcenter');
            } else if (id === 'playground') {
                location.href = '/playground/lod/';
            } else if (id === 'question') {
                location.href = '/devcenter/commonQuestion/';
                //20210309 by wyx
            } else if (id === 'logs') {
                location.href = '/devcenter/updateLogs/';
            }
            // else if (id === 'application') {
            //     location.href = '/devcenter/applicationScenarios/';
            // }
        },
        getImgUrl(url) {
            return `${process.env.STATIC}${url}`;
        },
        pathTo(url) {
            if (url && url !== '') {
                this.$router.push(url);
            }
        },
        indexUserLogin() {
            userLogin();
        },
        getUserInfo() {
            getUserNameFun().then((accountRes) => {
                this.userName = accountRes.displayName;
            });
        },
    },
    mounted() {
        const _self = this;
        _self.getUserInfo();
        // 请求首页数据
        get(homePageUrl).then((res) => {
            if (res) {
                this.obvFeatureData = res.homePage;
                this.featureIntroduceData = res.featuresIntroduce;
                this.solutionsData = res.solutions;
                this.aboutUsData = res.aboutUs;
                // 图片地址替换
                res.cases.forEach((ele) => {
                    ele.img = `${process.env.STATIC}${ele.img}`;
                });
                // 用户案例数据
                this.caseData = res.cases;
            }
        });
    },
    created() {},
};
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/variable'
@import '~common/stylus/mixin'

.home-page
  // bg_img('../../../static/dataMock/homePage/HPbanner1.png')
  //  @media (min-width: 641px) and (max-width: 768px)
  @media (max-width: 768px)
    height 500px
  @media (min-width: 769px) and (max-width: 1024px)
    height 768px
  @media (min-width: 1025px) and (max-width: 1280px)
    height 768px
  @media (min-width: 1281px) and (max-width: 1366px)
    height 768px
  @media (min-width: 1367px) and (max-width: 1440px)
    height 850px
  @media (min-width: 1441px) and (max-width: 1680px)
    height 900px
  @media (min-width: 1681px) and (max-width: 1920px)
    height 1080px

  .homePageImg
    width: auto
    height: auto
    max-width: 100%
    max-height: 100%
  overflow: hidden
  color: $font-white
  width: 100%
  height: 1080px
  padding: 0
  position: relative

  .hpBanner
    width 100%
    height 88px

    .hpBanner-loge
      position: absolute
      left: 5.3%
      top: 6%
      display: flex
      align-items: center

      .hpBanner-img
        position: relative
        width: 120px
        height: 26px

      .hpBanner-ctx
        width: 200px
        height: 36px
        font-size: $font-size-logo
        line-height: 46px
        margin-left 15px

    .hpBanner-header-lg
      position: absolute
      width: 100%
      margin 0 auto
      top 6%
      dom_center()
      flex-direction: row
      font-size: 16px

      .hpBanner-menu
        height 50px
        width 140px
        dom_center()
        border: 1px solid transparent
        border-radius 167px

        &:hover
          border: 1px solid $font-white
          transition border 1s ease

    .hpBanner-header-sm
      visibility hidden
      position: absolute;
      z-index 99
      right: 30px
      top 20px
      opacity 1
      flex-direction: column;

      .fade-enter, .fade-leave-to
        opacity: 0

      .fade-leave, .fade-enter-to
        opacity: 1

      .fade-enter-active, .fade-leave-active
        transition: all .2s

      .navicon-bar
        position: relative;
        left: calc(50% - 25px);
        font-size 25px
        height 50px
        width 50px
        dom_center()
        border 1px solid  $font-lightwhite

      .hpBanner-menuGroup
        position absolute
        right: 0px
        border-radius 5px
        background-color $background-lightblack
        margin-top 5px

        .hpBanner-menu
          height 50px
          width 120px
          dom_center()
          border: 1px solid transparent

          &:hover
            border: 1px solid $font-white
            transition border 1s ease

    .hpBanner-login
      position absolute
      right 4.32%
      top 55px
      display flex

      .loginCenter
        line-height 50px
        display block
        font-size 20px
        font-weight bold
        margin-right: 30px
        cursor pointer

      .loginSty
        dom_center()
        width 120px
        height 50px
        font-size 18px
        background: rgba(6, 243, 255, 0.40)
        border: 2px solid #06F3FF
        border-radius: 25px;
        cursor pointer
        overflow hidden
        text-overflow ellipsis
        white-space nowrap

        &:hover
          background: rgba(6, 243, 255, 0.80)

  .hpContent
    @media (max-width: 1980px)
      top: 14%
      h3:nth-of-type(1)
        font-size 30px

      h3:nth-of-type(2)
        margin-top: 30px;
        font-size 25px
        color $font-lightwhite

      h2:nth-of-type(1)
        margin-top: 30px;
        font-size 50px

      .hpContent-btnGroup
        display flex

        .hpContent-btn
          dom_center()
          margin-top 30px
          margin-right 30px
          font-size $font-size-logo
          width 200px
          height 60px
          background: rgba(6, 243, 255, 0.40)
          border: 2px solid #06F3FF
          border-radius: 30px
          cursor pointer

          &:hover
            background: rgba(6, 243, 255, 0.80)
    @media (max-width: 768px)
      top: 11%
      h3:nth-of-type(1)
        font-size 15px

      h3:nth-of-type(2)
        display none

      h2:nth-of-type(1)
        margin-top: 3%;
        font-size 12px

      .hpContent-btnGroup
        flex-direction row

        .hpContent-btn
          dom_center()
          margin-top 5%
          margin-right 30px
          font-size 16px
          width 120px
          height 30px
    // .hpContent-btn:nth-of-type(1)
    //   display: none
    position absolute
    left: 5.3%

  .hpFeature
    @media (max-width 1980px)
      bottom 11%
      .hpFeature-sub
        width 15.7%
        height 287px
        margin-left 3.33%
        padding: 27px;

        h2:nth-of-type(1)
          padding-top 20px
          font-size 21px

        h3:nth-of-type(1)
          padding-top 20px
          height 47%
          overflow hidden
          font-size $font-size-text

        .subImage-container
          width 54px
          height 54px
          margin-top 7.3%
          display flex
          align-items: center;
          justify-content: center;

          .subImage
            max-width 52.5px
            height auto
    @media (max-width 1440px)
      .hpFeature-sub
        height 207px

        h2:nth-of-type(1)
          padding-top 10px
          font-size 16px

        .subImage-container
          width 40px
          height 40px
          margin-top 7.3%
          display flex
          align-items: center;
          justify-content: center;

          .subImage
            max-width 40px
            height auto
    @media (max-width 768px)
      bottom: 0px;
      top: 42%;
    position absolute
    width 100%
    display flex
    justify-content center

    .hpFeature-sub
      display flex
      flex-direction column
      color $font-black
      background $background-white
      border-radius 8px
      box-shadow 0px 22px 35px 0px $background-shadowBlue,
      20px 0 21px -20px $background-shadowBlue,
      -15px 0 15px -15px $background-shadowBlue
      align-items center

    .hpFeature-sub:nth-of-type(1)
      margin-left 0px

.features-introduce
  color $font-black
  width 100%
  dom_center()
  flex-wrap wrap

  .subIntroduce
    width 100%
    margin-top: 10%
    dom_center()

    .subLeft
      dom_center()
      width 45%

      .subImage
        width: auto
        height: auto
        max-width: 100%
        max-height: 100%
        z-index 1

      .subBG
        position absolute
        @media (max-width: 768px)
          width 152px
          height 116px
        // width 277px
        // height 180px
        @media (min-width: 769px) and (max-width: 1060px)
          width 327px
          height 245px
        @media (min-width: 1061px) and (max-width: 1280px)
          width 557px
          height 385px
        @media (min-width: 1281px) and (max-width: 1366px)
          width 573px
          height 450px
        @media (min-width: 1441px) and (max-width: 1680px)
          width 583px
          height 460px
        @media (min-width: 1681px) and (max-width: 1920px)
          width 687px
          height 500px
        z-index 0
        transform rotate(36deg)
        background-color rgb(240, 244, 253, 1)
        border-radius 505px

    .subRight
      width 50%
      flex-direction column
      dom_center()
      @media (max-width: 1920px)
        span:nth-of-type(1)
          font-size 52px
          font-weight 400

        span:nth-of-type(2)
          margin-top 5%
          font-size 20px
          width 50%
      @media (max-width: 768px)
        span:nth-of-type(1)
          font-size 18px
          font-weight 400

        span:nth-of-type(2)
          margin-top 5%
          font-size 10px
          width 50%

    .subLeft.left
      padding-left 13%

    .subLeft.right
      padding-right 13%
</style>



// WEBPACK FOOTER //
// src/pages/index/index.vue